/* https://codepen.io/danielmorosan/pen/XmYBVx */

.SpinnersContainer {
  display: block;
  text-align: center;
}

.SpinnerItem {
  animation: bounce-animation 1.4s infinite ease-in-out both;
  background-color: currentcolor;
  border-radius: 100%;
  display: inline-block;
  height: var(--space-lg);
  margin-right: var(--space-xxs);
  opacity: 50%;
  width: var(--space-lg);
}

.SpinnerItem:first-of-type {
  animation-delay: -0.32s;
}

.SpinnerItem:nth-of-type(2) {
  animation-delay: -0.16s;
}

@keyframes bounce-animation {
  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}
